import React from 'react';
import './noResultFound.scss'
import Search from '@images/features/search-img.png'

function NoResultFound() {

  const openBeacon = (e) => {
    e.preventDefault()
    window.Beacon('open')
  }

  return (
    <div className='no-result-found'>
      <div className="no-result-found__image">
        <img src={Search} alt="search" />
      </div>
      <h2>Sorry! No result found.</h2>
      <p>Try adjusting your search or filter to find what you’re looking for.</p>
      <p className="no-result-found__small-text">For more information you can visit our <a href="src/components/features/noResultFound/noResultFound#" onClick={openBeacon}>Help Center</a></p>
    </div>
  )
}

export default NoResultFound